<app-data-set
	#dataSet
	[dataSource]="dataSource"
	defaultPresentationMode="table"
	firstColumnProperty="device.serialNumber"
	[rowId]="rowId"
>
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				defaultFilterName="serialNumber"
				[defaultFilterLabel]="filterLabels.serialNumber"
				[placeholder]="filterLabels.defaultPlaceholder"
			>
				<div class="filter-grid" [style.--columns]="3">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.serialNumber }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('serialNumber')"
								data-automation-id="serial-number-input"
								(ngModelChange)="dataSet.filter('serialNumber', filterLabels.serialNumber, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.source }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('companyName')"
								data-automation-id="company-name-input"
								(ngModelChange)="dataSet.filter('companyName', filterLabels.source, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<!-- FIXME: FILTER FIXES -  should be dropdown -->
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.displayStatus }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('displayStatus')"
								data-automation-id="display-status-input"
								(ngModelChange)="dataSet.filter('displayStatus', filterLabels.displayStatus, $event)"
							/>
						</mat-form-field>
					</div>
				</div>

				<div class="filter-grid" [style.--columns]="3">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.propertyName }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('propertyName')"
								data-automation-id="property-name-input"
								(ngModelChange)="dataSet.filter('propertyName', filterLabels.propertyName, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.deviceLocation }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('deviceLocation')"
								data-automation-id="device-location-input"
								(ngModelChange)="dataSet.filter('deviceLocation', filterLabels.deviceLocation, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.townCity }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('townCity')"
								data-automation-id="city-input"
								(ngModelChange)="dataSet.filter('townCity', filterLabels.townCity, $event)"
							/>
						</mat-form-field>
					</div>
				</div>

				<!-- FIXME: FILTER FIXES -  Should use country code lookup -->
				<div class="filter-grid" [style.--columns]="3">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.country }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('country')"
								data-automation-id="country-input"
								(ngModelChange)="dataSet.filter('country', filterLabels.country, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.stateProvince }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('stateProvince')"
								data-automation-id="province-input"
								(ngModelChange)="dataSet.filter('stateProvince', filterLabels.stateProvince, $event)"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.postalCode }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('zipPostalCode')"
								data-automation-id="postal-code-input"
								(ngModelChange)="dataSet.filter('zipPostalCode', filterLabels.postalCode, $event)"
							/>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>
		<div *appActionGroup>
			<app-data-set-presentation-toggle data-automation-id="device-group-toggle"></app-data-set-presentation-toggle>
		</div>
		@if (canEditDevices) {
			<div *appActionGroup>
				<app-data-set-action-button
					icon="add"
					label="Add"
					i18n-label="@@device-groupAdd"
					data-automation-id="add-group-button"
					[isDisabled]="isCheckingDeviceGroupOwnership"
					(click)="onAddButtonClick()"
				></app-data-set-action-button>
			</div>
		}

		@if (canEditDevices) {
			<div *appSelectedActionGroup>
				<app-data-set-action-button
					class="destructive"
					icon="clear_icon"
					label="Remove from Group"
					i18n-label="@@device-groupRemoveFromGroup"
					data-automation-id="remove-group-button"
					(click)="removeDevicesFromGroup(selectedDevices)"
				>
				</app-data-set-action-button>
			</div>
		}
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (loadingService.isLoading(getDevicesByDeviceGroupIdLoadingKey) || !finishedLoadingInitData) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="loadingService.isLoading(getDevicesByDeviceGroupIdLoadingKey) || !finishedLoadingInitData"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="rowSelection">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						@if (canEditDevices) {
							<app-data-set-table-row-selection
								[data]="row"
								[appHasSystemCapability]
								has="deviceManagement"
							></app-data-set-table-row-selection>
						}
					</td>
				</ng-container>

				<ng-container matColumnDef="serialNumber">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>Serial Number</th>
					<td mat-cell *matCellDef="let row">{{ row.device.serialNumber }}</td>
				</ng-container>

				<ng-container matColumnDef="deviceLocation">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@device-groupDeviceLocation2">
						Device Location
					</th>
					<td mat-cell *matCellDef="let row">
						{{ row.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.name }}
					</td>
				</ng-container>

				<ng-container matColumnDef="propertyName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@device-groupPropertyName2">Property Name</th>
					<td mat-cell *matCellDef="let row">
						{{ row.device.activeDeviceAssignment?.activeInstallation?.installationLocation?.location?.name }}
					</td>
				</ng-container>

				<ng-container matColumnDef="companyName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@device-groupSource">Source</th>
					<td mat-cell *matCellDef="let row">
						<div class="source-container row-left spacing-8">
							@if (isOwnedDeviceGroup(row.device.activeDeviceAssignment?.company)) {
								<mat-icon class="icon-device-group-owned" svgIcon="sl-device-group-owned"></mat-icon>
							} @else {
								<mat-icon class="icon-device-group-inherited" svgIcon="sl-device-group-inherited"></mat-icon>
							}
							{{ row.device.activeDeviceAssignment?.company?.name }}
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="displayStatus">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@device-groupStatus">Status</th>
					<td mat-cell *matCellDef="let row" class="status-cell">
						<app-device-status
							[device]="row.device"
							[installation]="row.device.activeDeviceAssignment?.activeInstallation"
						></app-device-status>
					</td>
				</ng-container>

				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						@if (canEditDevices) {
							<app-data-set-table-menu
								[menu]="menu"
								[row]="row"
								[appHasSystemCapability]
								has="deviceManagement"
							></app-data-set-table-menu>
						}
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					(appDataSetRowClick)="onRowClick(row)"
					[attr.data-automation-id]="'device-group-' + row.id + '-row'"
				></tr>
			</table>
			<mat-menu #menu="matMenu">
				<ng-template matMenuContent let-row="row">
					<button
						mat-menu-item
						(click)="removeDevicesFromGroup([row.device])"
						i18n="@@device-groupRemoveFromGroup2"
						data-automation-id="remove-from-group-button"
					>
						Remove from Group
					</button>
				</ng-template>
			</mat-menu>
		</app-data-set-table-view>

		<!-- Do not load this in if unit testing -->
		@if (!env.isTesting) {
			<app-data-set-map-view></app-data-set-map-view>
		}
	</app-data-set-content>
</app-data-set>
